import angular from 'angular';
import { PaymentSection } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-payments';

angular.module(moduleName, []).directive('paymentsSection', [
    'Backoffice',
    (Backoffice) => ({
        restrict: 'A',
        link: (_scope, el) => {
            Backoffice.renderComponent(el[0], PaymentSection);

            // Al destruirse, desmontar el root de React (evita fugas en body).
            _scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    }),
]);

export default moduleName;
